


const rare: Record<string, any> = {
  
}
export default rare